import { Injectable } from '@angular/core';
import { Lookup } from '@common/utilities/Lookup';
import { ApiService } from './api.service';
import { DataService, ServiceGroupRecord } from './data.service';
import { SynchronizationService } from './synchronization.service';

@Injectable({
  providedIn: 'root'
})
export class GroupsService {

  private lookupById = new Lookup<ServiceGroupRecord>(i => i.ID);

  private _sync(notify = true) {

    if (notify) this.sync.notify(GroupsService, false);    

    this.ds.groups('list').subscribe(services => {

      if (services) {
        this.lookupById.source = services;

        this.sync.notify(GroupsService, true);
      }
      else {
        if (this.api.authorized) {
          this._sync(false);
        }
        else {
          this.api.credentialChanged.subscribe(user => {
            this._sync(false);
          });
        }
      }
    });
  }

  public synchronize() {
    this._sync();
  }

  private clone(group: ServiceGroupRecord): ServiceGroupRecord {
    return group ? { ...group } : null;
  }

  public get(id: number): ServiceGroupRecord {
    return this.lookupById.get(id, null);
  }

  public get all(): ServiceGroupRecord[] {
    return this.lookupById.source.map(i => this.clone(i));
  }

  constructor(private ds: DataService, private api: ApiService, private sync: SynchronizationService) {
    this._sync();
  }
}
